import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getTriggerEvents, getReplyTo, getTags, getSingleTemplet } from "../../../ReduxStore/Slice/Templets/EmailTemplet";
import JoditEditor from 'jodit-react';
import { PenLine } from 'lucide-react';

const ReadOnlyEmailTemplate = () => {
    const editor = useRef(null);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));

    const [triggerEventsData, setTriggerEventsData] = useState([]);
    const [getTagsData, setTagsData] = useState({
        client: [],
        practice: [],
        user_profile: [],
        others: []
    });
    const [ReplyToData, setReplyToData] = useState([]);
    const [formData, setFormData] = useState({
        templateName: "",
        description: "",
        triggerEvent: "",
        subjectLine: "",
        bccEmail: "",
        replyTo: "",
        body: "",
        attachments: [],
    });

    const [activeTab, setActiveTab] = useState("Client");

    useEffect(() => {
        const fetchData = async () => {
            const req = { agent_id };
            await Promise.all([
                dispatch(getTriggerEvents(req)).unwrap(),
                dispatch(getReplyTo(req)).unwrap(),
                dispatch(getTags(req)).unwrap()
            ]).then(([triggerRes, replyRes, tagsRes]) => {
                if (triggerRes.status) setTriggerEventsData(triggerRes.data);
                if (replyRes.status) setReplyToData(replyRes.data);
                if (tagsRes.status) {
                    setTagsData({
                        client: tagsRes.data.filter(d => d.type === "client"),
                        practice: tagsRes.data.filter(d => d.type === "practice"),
                        user_profile: tagsRes.data.filter(d => d.type === "user_profile"),
                        others: tagsRes.data.filter(d => d.type === "other" && d.name !== "services" && d.name !== "chargebasis")
                    });
                }
            });
        };
        fetchData();
    }, [agent_id, dispatch]);

    useEffect(() => {
        if (triggerEventsData.length > 0 && ReplyToData.length > 0) {
            const fetchTemplate = async () => {
                const req = { id: location?.state?.row?.id || location?.state?.id, agent_id };
                await dispatch(getSingleTemplet(req)).unwrap().then((res) => {
                    if (res.status) {
                        setFormData({
                            templateName: res.data.name,
                            description: res.data.description,
                            triggerEvent: res.data.template_trriger_id,
                            subjectLine: res.data.subject,
                            bccEmail: res.data.bcc_mail,
                            replyTo: res.data.reply_to,
                            body: res.data.body,
                            attachments: res.data.attachments || [],
                        });
                    }
                });
            };
            fetchTemplate();
        }
    }, [triggerEventsData, ReplyToData, agent_id, dispatch, location]);

    const config = useMemo(() => ({
        readonly: true,
        toolbar: false,
        showCharsCounter: false,
        showWordsCounter: false,
        showStatusbar: false,
        height: 400,
    }), []);

    const tags = [
        { id: "Client", name: "Client" },
        { id: "Practice", name: "Practice" },
        { id: "User_Profile", name: "User Profile" },
        { id: "others", name: "Others" },
    ];

    return (
        <div className="row mb-4 mt-2">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header d-sm-flex justify-content-between align-items-center">
                        <h5 className="card-title mb-0">View Email Template</h5>
                        <div className="d-flex">
                            <PenLine
                                className="me-4 cursor-pointer"
                                onClick={() =>
                                    navigate(`/admin/template/edit-email-template`, {
                                        state: { id: location?.state?.row?.id || location?.state?.id },
                                    })
                                }
                            />
                        </div>
                    </div>
                    <div className="card-body tempaltes">
                        <div className="row mb-4">
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <label className="col-sm-3 col-form-label">Template name:</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={formData.templateName} disabled />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <label className="col-sm-3 col-form-label">Description:</label>
                                    <div className="col-sm-9">
                                        <textarea className="form-control" value={formData.description} disabled></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <label className="col-sm-3 col-form-label">Trigger Event :</label>
                                    <div className="col-sm-9">
                                        <select className="form-select" value={formData.triggerEvent} disabled>
                                            {triggerEventsData.map(data => (
                                                <option key={data.id} value={data.id}>{data.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <label className="col-sm-3 col-form-label">Subject:</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={formData.subjectLine} disabled />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <label className="col-sm-3 col-form-label">BCC Email:</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={formData.bccEmail} disabled />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <label className="col-sm-3 col-form-label">Reply to:</label>
                                    <div className="col-sm-9">
                                        <select className="form-select" value={formData.replyTo} disabled>
                                            {ReplyToData.map(data => (
                                                <option key={data.id} value={data.id}>{data.email}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <label className="col-sm-12 col-form-label">Body:</label>
                                    <div className="col-sm-12">
                                        <JoditEditor ref={editor} config={config} value={formData.body || ""} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReadOnlyEmailTemplate;
